import React from 'react';
import { DOMAIN_LABELS } from '../api/ticketsApi';

function TicketDomainBadge({ domain }) {
  const key = (domain || '').toLowerCase();
  return (
    <span className={`tk-pill tk-pill-domain-${key || 'software'}`}>
      {DOMAIN_LABELS[key] || domain || '—'}
    </span>
  );
}

export default TicketDomainBadge;
